import { groupBy, nutrition } from "../omnia";
import { CroppingInfo } from "./cropping-info";
import { NotificationGroup } from "./types";

export function checkManureAreas(cropping: CroppingInfo[], year: number, hasRiskMap: boolean): NotificationGroup {

    if (hasRiskMap) {
        return null;
    }

    let issues = cropping.filter(c => {
        if (nutrition.isCropIgnoredForNutrition(c.cropId)) return false;
        if (!c.field.manureSpredableArea) return false;
        return (!c.manureSpredableArea);
    });

    let fields = groupBy(issues, i => i.field, i => i.fieldId);

    if (!issues.length) {
        return null;
    }

    let details = fields.map(i => {
        return {
            text: i.key.name + ` - manure spreadable area: ${i.key.manureSpredableArea} ha`,
        };
    });

    details = details.sort((d1, d2) => d1.text.localeCompare(d2.text));

    return {
        id: "manure-area",
        summary: "Manure spreadable area cannot be determined automatically",
        description: `
            <p>Some fields have a specific manure spreadable area, which cannot be applied to its associated crops either because the crop area differs from that of the field, or because there are multiple crops on the field.</p>
            <p>You should set a spreadable area for the crops on those fields. You can also draw an risk map for year ${year} using the Manure module.</p>
            `,
        error: true,
        details,
    };

}
